import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { createBrowserHistory, createHashHistory } from "history";
import rootReducer from "./modules/reducers";

// set up redux
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(thunk)));

const browser = createBrowserHistory();
const hash = createHashHistory();

if (DEVELOPMENT) {
  console.warn("Qbpanel is running in development mode");
  console.warn("Set window.debugLocation to true to see route changes dumps");
  browser.listen((location) => {
    if (window.debugLocation) {
      console.group("location changed");
      console.log("new path: ", location.pathname);
      console.log("query string: ", location.search);
      console.log("action: ", location.action);
      console.groupEnd();
    }
  });
}

export const history = IS_APP ? hash : browser; //syncHistoryWithStore(, store);
